import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoader } from "../../contexts/loader";

export function useAuthRoute(
  WrappedComponent,
  requiredPermission,
  nivelExigido
) {
  const sessao = JSON.parse(localStorage.getItem("sessao")) || {};
  const { fecharCarregamento, fecharCarregamentoTabela } = useLoader();

  const usuarioPerfilEmpresaDTO =
    sessao?.usuarioLogadoDTO?.usuarioPerfilEmpresaDTO || {};
  const { listaPrivilegios = {}, tipoPerfilUsuario = "" } =
    usuarioPerfilEmpresaDTO;

  const listaPrivilegiosKeys = Object.keys(listaPrivilegios);

  function verificarNivel(nivel) {
    let nivelAtual = 0;

    if (nivel === "CONSULTAR_PERMITIR") {
      nivelAtual = 1;
    }
    if (nivel === "ALTERAR") {
      nivelAtual = 2;
    }
    if (nivel === "INSERIR") {
      nivelAtual = 3;
    }
    if (nivel === "EXCLUIR") {
      nivelAtual = 4;
    }

    if (tipoPerfilUsuario === "MASTER") {
      nivelAtual = 4;
    }
    return nivelAtual;
  }

  const permissoesRequeridas = Array.isArray(requiredPermission)
    ? requiredPermission
    : requiredPermission
      ? [requiredPermission]
      : [];

  let autorizado = true;

  if (tipoPerfilUsuario !== "MASTER" && permissoesRequeridas.length > 0) {
    const possuiAlgumaPermissao = permissoesRequeridas.some((permission) =>
      listaPrivilegiosKeys.includes(permission)
    );

    if (!possuiAlgumaPermissao) {
      autorizado = false;
    } else if (nivelExigido) {
      const nivelExigidoNumerico = verificarNivel(nivelExigido);
      const nivelMaximoUsuario = Math.max(
        ...permissoesRequeridas.map((permission) =>
          verificarNivel(listaPrivilegios[permission])
        )
      );
      if (nivelMaximoUsuario < nivelExigidoNumerico) {
        autorizado = false;
      }
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (!autorizado) {
      toast.error("Você não possui permissão para acessar essa página!");
      fecharCarregamentoTabela();
      fecharCarregamento();
      navigate("/");
    }
  }, [autorizado]);

  if (!autorizado) {
    return null;
  }

  return <WrappedComponent />;
}